import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-remove-user-id-modal',
    templateUrl: './remove-user-id-modal.component.html',
    styleUrls: ['./remove-user-id-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class RemoveUserIdModalComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Output() removed = new EventEmitter();
  @Output() canceled = new EventEmitter();
  @Input() modalId = 'remove-auto-check-user-id-modal';

  show() {
    this.modal.show();
  }

  cancel() {
    this.canceled.emit();
    this.close();
  }

  remove() {
    this.removed.emit(true);
    this.close();
  }

  close() {
    this.modal.close();
  }
}
